import DynamicSectionElement from '@/js/dynamic-section-element';

class CountdownTimer extends DynamicSectionElement {
  constructor() {
    super();

    this.startTimer();
  }

  startTimer() {
    const launchDateAttribute = this.getAttribute('launch-date');
    const MILLISECONDS_PER_SECOND = 1000;
    const MILLISECONDS_PER_MINUTE = MILLISECONDS_PER_SECOND * 60;
    const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * 60;
    const MILLISECONDS_PER_DAY = MILLISECONDS_PER_HOUR * 24;

    if (!launchDateAttribute) {
      return;
    }

    this.launchDate = Date.parse(launchDateAttribute); // Converts from ISO 8601 to milliseconds
    this.reRenderDuration = 1000; // 1 second
    this.variantId = this.dataset.variantId; // The countdown timer associated with the variant

    // Update the count down every 1 second
    this.intervalId = setInterval(() => {
      // Find the delta between now and the count down date
      let delta = this.getDelta();

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(delta / MILLISECONDS_PER_DAY);
      let hours = Math.floor(
        (delta % MILLISECONDS_PER_DAY) / MILLISECONDS_PER_HOUR
      );
      let minutes = Math.floor(
        (delta % MILLISECONDS_PER_HOUR) / MILLISECONDS_PER_MINUTE
      );
      let seconds = Math.floor(
        (delta % MILLISECONDS_PER_MINUTE) / MILLISECONDS_PER_SECOND
      );

      // Display the result in the element
      this.updateCounter('days', days);
      this.updateCounter('hours', hours);
      this.updateCounter('minutes', minutes);
      this.updateCounter('seconds', seconds);

      // Clear out the timer if delta is less than 0
      if (delta < 0) {
        this.clearCounter();
        clearInterval(this.intervalId);
        this.hideTimer();
      } else {
        this.showTimer();
      }
    }, this.reRenderDuration);
  }

  /**
   * Clears the interval and sets all values to 0 to prevent displaying negative numbers
   * @returns void
   */
  clearCounter() {
    this.updateCounter('days', 0);
    this.updateCounter('hours', 0);
    this.updateCounter('minutes', 0);
    this.updateCounter('seconds', 0);
  }

  /**
   *  updates the DOM for the given time entry
   * @param {timestamp} timeEntry
   * @param {timestamp} timeValue
   * @returns void
   */
  updateCounter(timeEntry, timeValue) {
    this.querySelector(`[${timeEntry}-counter]`).innerHTML = timeValue;
  }

  /**
   * Calculates the delta between now and the launch date
   * @returns {timestamp} the delta between now and the launch date
   */
  getDelta() {
    return this.launchDate - Date.now();
  }

  /**
   * Shows the countdown timer
   * @returns {void}
   */
  showTimer() {
    this.querySelector('[data-countdown-timer]').classList.remove('hide');
  }

  /**
   * Hides the countdown timer
   * @returns {void}
   */
  hideTimer() {
    this.querySelector('[data-countdown-timer]').classList.add('hide');
  }

  /**
   * Fires when the element is removed from the DOM
   */
  disconnectedCallback() {
    clearInterval(this.intervalId);
  }
}

customElements.get('countdown-timer') ||
  customElements.define('countdown-timer', CountdownTimer);
